import { render, staticRenderFns } from "./draftPage.vue?vue&type=template&id=d6ccd0ba&scoped=true&"
import script from "./draftPage.vue?vue&type=script&lang=js&"
export * from "./draftPage.vue?vue&type=script&lang=js&"
import style0 from "./draftPage.vue?vue&type=style&index=0&id=d6ccd0ba&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ccd0ba",
  null
  
)

export default component.exports